import { render } from "./ClaimsComponent.vue?vue&type=template&id=6d7d4b02&ts=true"
import script from "./ClaimsComponent.vue?vue&type=script&lang=ts"
export * from "./ClaimsComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__